import { render } from "./Menu-organico.vue?vue&type=template&id=9e10ea44"
import script from "./Menu-organico.vue?vue&type=script&lang=js"
export * from "./Menu-organico.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__